import PageHeader from "../components/PageHeader";
import { ABOUT_IMAGE, COMPANY, STATS } from "../data/site";

export default function Azienda() {
  return (
    <>
      <PageHeader
        eyebrow="Azienda"
        title="50+ anni di esperienza, una sola passione."
        description="Un'eredità familiare che dal 1970 accompagna il territorio nella realizzazione di opere edili, stradali e specialistiche."
      />

      <section data-reveal className="py-20 md:py-28 bg-white border-b border-neutral-200">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="overline mb-6">/ La nostra storia</div>
            <div className="stat-number text-[#1D4ED8]">{COMPANY.experience}</div>
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500 mt-2">
              Anni di attività
            </div>
          </div>
          <div className="md:col-span-7 space-y-6 text-lg text-neutral-700 leading-relaxed">
            <p>
              <strong className="text-[#0B1E3F]">Qui comincia il nostro progetto</strong>, basato
              sull'esperienza passata e presente per costruire il futuro.
            </p>
            <p>
              La nostra azienda opera da svariati anni nel settore delle costruzioni. Da più di mezzo
              secolo ci avvaliamo dell'esperienza e passione del suo titolare — fattore tramandato ai
              propri figli, oggi parte integrante e solida dell'attuale struttura organizzativa
              dell'impresa.
            </p>
            <p>
              Operiamo su scala locale, costituendo un punto di riferimento per le aziende del settore.
              Ci distinguiamo per la versatilità dei servizi e la disponibilità di risorse e mezzi
              specializzati, con i quali affrontiamo in autonomia lavori edili e stradali, opere di
              difesa del suolo, opere fognarie, acquedotti, opere di ingegneria naturalistica e sgombero
              neve.
            </p>
          </div>
        </div>
      </section>

      <section data-reveal className="relative min-h-[70vh] bg-[#0B1E3F] text-white overflow-hidden">
        <img src={ABOUT_IMAGE} alt="Mezzi Fratelli D'Ambrosio" className="absolute inset-0 w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1E3F] via-[#0B1E3F]/40 to-transparent" />
        <div className="grain" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32 flex items-end min-h-[70vh]">
          <div className="max-w-3xl">
            <div className="overline text-[#60A5FA] mb-6">/ La missione</div>
            <h2 className="hero-title text-white text-4xl md:text-5xl lg:text-6xl">
              Costruire con<br />
              <span className="text-[#60A5FA]">serietà, metodo</span><br />
              e rispetto del territorio.
            </h2>
          </div>
        </div>
      </section>

      <section data-reveal className="py-20 md:py-28 bg-[#F5F5F3]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="overline mb-6">/ I numeri</div>
          <h2 className="hero-title text-4xl md:text-5xl lg:text-6xl mb-16 max-w-3xl">
            Numeri che raccontano<br />chi siamo.
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
            {STATS.map((s, i) => (
              <div key={i} className="bg-white p-8 md:p-10">
                <div className="stat-number text-[#0B1E3F]">{s.value}</div>
                <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-neutral-500 mt-4">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
